export interface AudienceTagSelection {
  uetTag: string
  domainId: number | undefined
  id: number | undefined
}

export const defaultAudienceTag = {
  uetTag: '',
  domainId: undefined,
  id: undefined,
}

export const validateInputOnlyNumbers = (e: React.ChangeEvent<HTMLInputElement>) => {
  const re = /^[0-9]+$/
  if (e.target.value === '' || re.test(e.target.value)) {
    return true
  }
  return false
}
